import { useEffect, useState } from "react";
import { useAuth } from "@components/auth-provider/AuthProvider";

const DISMISSED_KEY = "mobile-app-banner-dismissed";
const DISMISSED_EVENT = "mobile-app-banner-dismissed";

const isMobileDevice = () => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  return isIOS || isAndroid;
};

export function useMobileAppBanner() {
  const auth = useAuth();
  const token = auth.getAuthToken();
  const mobileScheme = import.meta.env.VITE_MOBILE_SCHEME;
  const isMobile = isMobileDevice();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === "true"
  );

  useEffect(() => {
    const handler = () => setDismissed(true);
    window.addEventListener(DISMISSED_EVENT, handler);
    return () => window.removeEventListener(DISMISSED_EVENT, handler);
  }, []);

  const appUrl = `${mobileScheme}://pes-noexc?token=${token}`;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setDismissed(true);
    window.dispatchEvent(new Event(DISMISSED_EVENT));
  };

  return { isMobile, dismissed, dismiss, appUrl };
}
